<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container has-margin-top-30" v-if="!loading">
      <div class="columns is-vcentered">
        <div class="column is-2 is-offset-2 has-text-centered-mobile">
          <img v-if="event" :src="`${event.imgUrl}`" style="width: 150px" />
        </div>
        <div class="column is-6 has-text-centered-mobile">
          <h1 class="title">{{ event.eventname }}</h1>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div v-if="entry.paid && event.config && event.config.freeevent">
                <h1 class="title">Thank you for signing up.</h1>
              </div>
              <div v-if="entry.paid && event.config && !event.config.freeevent">
                <h1 class="title">
                  Thank you for signing up. <br />
                  Your entry is marked as paid.
                </h1>
              </div>
              <div v-if="!entry.paid && $route.name === 'EventRegistered'">
                <h1 class="title">Step 2: Complete Payment</h1>
                <p v-if="entry && event">
                  Please pay
                  <strong>{{
                    priceFormatter(
                      entry.entryfee,
                      event.paymentdetails.currency
                    )
                  }}</strong>
                  to complete your registration.
                </p>
                <p>
                  You have 15 minutes to complete payment otherwise your entry
                  will be deleted.
                </p>
              </div>
              <div v-if="!entry.paid && $route.name === 'PayForEvent'">
                <h1 class="title">Complete Payment</h1>
                <p v-if="entry && event">
                  Please pay
                  <strong>
                    {{
                      priceFormatter(
                        entry.entryfee,
                        event.paymentdetails.currency
                      )
                    }}</strong
                  >
                  to complete your registration.
                </p>
              </div>

              <div v-if="!entry.paid">
                <p><strong>Payment Methods:</strong></p>
                <b-tabs
                  v-if="event.paymentmethods && event.paymentmethods.length > 0"
                >
                  <b-tab-item
                    label="EFT"
                    v-if="event.paymentmethods.includes('EFT')"
                  >
                    <div v-html="event.paymentdetails.bankdetails"></div>
                    <br />
                    <UploadFile
                      label="Upload Proof of Payment"
                      v-model="pop"
                      @input="updatePop"
                      rules="required"
                      folder="pop"
                    />
                  </b-tab-item>
                  <b-tab-item
                    label="Other"
                    v-if="event.paymentmethods.includes('Custom')"
                  >
                    <div v-html="event.paymentdetails.bankdetails"></div>
                  </b-tab-item>
                  <b-tab-item
                    label="PayFast"
                    v-if="event.paymentmethods.includes('PayFast')"
                  >
                    <div class="has-text-centered">
                      <p>
                        <a :href="`/payment/complete-payment/${entry._id}`"
                          ><img alt="Pay Now" src="/img/paynow-light.png"
                        /></a>
                      </p>
                      <p>
                        <img
                          alt="PayFast Secure Payments"
                          src="/img/secure-payments.png"
                        />
                        <img
                          alt="Payment Options"
                          src="/img/payment-methods-masterpass-1.png"
                        />
                      </p>
                    </div>
                  </b-tab-item>
                  <b-tab-item
                    label="Stripe"
                    v-if="event.paymentmethods.includes('Stripe')"
                  >
                    <b-button
                      @click="doStripeAction()"
                      class="button is-primary has-margin-right-10"
                      :loading="stripeLoading"
                      >Pay with Card</b-button
                    >
                    <b-button
                      @click="sofortAction()"
                      class="button is-primary"
                      :loading="sofortLoading"
                      v-if="event.paymentmethods.includes('Sofort')"
                      >Pay with Sofort</b-button
                    >
                  </b-tab-item>
                </b-tabs>
              </div>
              <p class="has-margin-top-15">
                Please send any event queries to
                <a
                  :href="`mailto:${event.eventdetails.contactemail}`"
                  target="_blank"
                  >{{ event.eventdetails.contactemail }}</a
                >.
              </p>

              <!-- <div v-if="event" v-html="event.paymentcontent"></div> -->
              <div
                v-if="entry.entrytype === 'Team' && !entry.prepaid"
                class="has-text-centered has-margin-top-30"
              >
                <p>
                  <strong>Next step:</strong> Choose your team members. Make
                  sure they sign up to CaptureFit to complete the waiver and
                  provide their emergency contact details.
                </p>
                <b-button
                  class="is-primary has-margin-top-15"
                  v-if="entry"
                  tag="router-link"
                  :to="{
                    name:
                      event.config && event.config.groupedteams
                        ? 'ManageGroupedTeam'
                        : 'ManageTeam',
                    params: { id: entry._id },
                  }"
                  >Choose Team Members</b-button
                >
              </div>
              <div
                class="has-text-centered has-margin-top-15"
                v-if="!entry.prepaid"
              >
                <div class="is-block has-text-centered">
                  <router-link :to="{ name: 'Home' }"> Go Home </router-link>
                </div>
              </div>
              <div
                class="has-text-centered has-margin-top-15"
                v-if="entry.prepaid && pop"
              >
                <div class="is-block has-text-centered">
                  <router-link
                    class="button btn-align no-lh raised is-medium primary-btn"
                    :to="{ name: 'CompleteEntry' }"
                    >Complete Entry</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global Stripe */
import { mapActions, mapGetters } from "vuex";
import EventEntryApi from "@/api/event-entry";
import StripeApi from "@/api/stripe";
import Vue from "vue";
import UploadFile from "@/components/UploadFile";

export default {
  components: {
    UploadFile,
  },
  data() {
    return {
      loading: true,
      entry: null,
      stripeLoading: false,
      sofortLoading: false,
      pop: "",
    };
  },
  computed: {
    ...mapGetters(["event"]),
  },
  async created() {
    try {
      this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
      if (window.fbq) {
        window.fbq("track", "Purchase", {
          currency: "USD",
          value: this.entry.entryfee,
        });
      }
      this.$gtag.purchase({
        transaction_id: this.entry._id,
        value: this.entry.entryfee,
        items: [
          {
            name: this.entry.event.eventname,
            price: this.entry.entryfee,
            quantity: 1,
          },
        ],
      });
      await this.getEvent(this.entry.event._id);
      if (
        this.event &&
        this.event.paymentmethods &&
        this.event.paymentmethods.includes("Stripe")
      ) {
        this.initStripe();
      }
      this.loading = false;
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    ...mapActions(["getEvent"]),
    async updatePop() {
      if (this.pop) {
        await EventEntryApi.updatePop(this.entry._id, this.pop);
      }
    },
    initStripe() {
      const tag = document.createElement("script");
      tag.setAttribute("src", `https://js.stripe.com/v3/`);
      tag.setAttribute("id", "cloudflareplayer");
      tag.setAttribute("type", "text/javascript");
      tag.onload = () => {};
      document.head.appendChild(tag);
    },
    getSiteUrl() {
      return location.protocol + "//" + location.host;
    },
    async doStripeAction() {
      try {
        this.stripeLoading = true;
        const session = await StripeApi.createstripesession(this.entry);
        const stripeDetails = StripeApi.getstripedetails(this.entry);
        const stripe = new Stripe(stripeDetails.publickey);
        await stripe.redirectToCheckout({ sessionId: session.id });
      } catch (err) {
        this.stripeLoading = false;
        this.$buefy.toast.open({
          message: "Error contacting Stripe",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
    async sofortAction() {
      try {
        this.sofortLoading = true;
        const stripeDetails = await StripeApi.getstripedetails(this.entry);
        const stripe = new Stripe(stripeDetails.publickey);
        const result = await stripe.createSource({
          type: "sofort",
          amount: this.entry.entryfee * 100,
          currency: stripeDetails.currency,
          redirect: {
            return_url: this.getSiteUrl() + "/stripe-payment/notify-source",
          },
          sofort: {
            country: stripeDetails.country,
          },
        });

        if (result.source) {
          await StripeApi.addstripesource(
            result.source.id,
            result.source.client_secret,
            this.entry._id
          );
          window.location = result.source.redirect.url;
        } else {
          console.log(result.error);
          this.$buefy.toast.open({
            message: "Sofort Error: " + result.error,
            position: "is-top",
            type: "is-danger",
          });
          this.sofortLoading = false;
        }
      } catch (err) {
        this.sofortLoading = false;
        this.$buefy.toast.open({
          message: "Error contacting Stripe (Sofort)",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
    priceFormatter(price, currency) {
      let display = "";
      switch (currency) {
        case "ZAR":
          display = `R${price} ZAR`;
          break;
        case "USD":
          display = `$${price} USD`;
          break;
        case "EUR":
          display = `€${price} EUR`;
          break;
        case "GBP":
          display = `£${price} GBP`;
          break;
        case "NAD":
          display = `N$${price} NAD`;
          break;
      }
      return display;
    },
  },
};
</script>